export default {
  methods: {
    getPaises () {
      return [
        { 'nacionalidad': 'AFGANA', 'pais': 'AFGANISTÁN' },
        { 'nacionalidad': 'ALBANESA', 'pais': 'ALBANIA' },
        { 'nacionalidad': 'ALEMANA', 'pais': 'ALEMANIA' },
        { 'nacionalidad': 'BURKINÉS', 'pais': 'BURKINA FASO' },
        { 'nacionalidad': 'ANDORRANA', 'pais': 'ANDORRA' },
        { 'nacionalidad': 'ANGOLEÑA', 'pais': 'ANGOLA' },
        { 'nacionalidad': 'ANTIGUANA', 'pais': 'ANTIGUA Y BARBUDA' },
        { 'nacionalidad': 'ARGELINA', 'pais': 'ARGELIA' },
        { 'nacionalidad': 'ARGENTINA', 'pais': 'ARGENTINA' },
        { 'nacionalidad': 'ARMENIA', 'pais': 'ARMENIA' },
        { 'nacionalidad': 'AUSTRALIANA', 'pais': 'AUSTRALIA' },
        { 'nacionalidad': 'AUSTRIACA', 'pais': 'AUSTRIA' },
        { 'nacionalidad': 'AZERBAYANO', 'pais': 'AZERBAIYÁN REP.' },
        { 'nacionalidad': 'BAHAMESA', 'pais': 'BAHAMAS' },
        { 'nacionalidad': 'BAHREINA', 'pais': 'BAHREIN' },
        { 'nacionalidad': 'BANGLADESHA', 'pais': 'BANGLADESH' },
        { 'nacionalidad': 'BARBADESA', 'pais': 'BARBADOS' },
        { 'nacionalidad': 'BIELORRUSA', 'pais': 'BIELORRUSA REP.' },
        { 'nacionalidad': 'BELGA', 'pais': 'BELGICA' },
        { 'nacionalidad': 'BELICEÑA', 'pais': 'BELICE' },
        { 'nacionalidad': 'BENINESA', 'pais': 'BENIN REP.' },
        { 'nacionalidad': 'BUTANESA', 'pais': 'BUTÁN' },
        { 'nacionalidad': 'BIRMANA/MYANMA', 'pais': 'BIRMANIA/MYANMAR' },
        { 'nacionalidad': 'BOLIVIANA', 'pais': 'BOLIVIA' },
        { 'nacionalidad': 'BOSNIA', 'pais': 'BOSNIA Y HERZEGOVINA' },
        { 'nacionalidad': 'BOTSWANESA', 'pais': 'BOTSWANA' },
        { 'nacionalidad': 'BRASILEÑA', 'pais': 'BRASIL' },
        { 'nacionalidad': 'BRUNEANA', 'pais': 'BRUNEI DARUSSALAM' },
        { 'nacionalidad': 'BULGARA', 'pais': 'BULGARIA' },
        { 'nacionalidad': 'BURUNDESA', 'pais': 'BURUNDI' },
        { 'nacionalidad': 'BUTANA', 'pais': 'BUTAN' },
        { 'nacionalidad': 'CAMBOYANA', 'pais': 'KHEMER REP DE CAMBOYA' },
        { 'nacionalidad': 'CAMERUNESA', 'pais': 'CAMERUN' },
        { 'nacionalidad': 'CANADIENSE', 'pais': 'CANADA' },
        { 'nacionalidad': 'CENTROAFRICANA', 'pais': 'REP CENTROAFRICANA' },
        { 'nacionalidad': 'CHADEÑA', 'pais': 'CHAD' },
        { 'nacionalidad': 'CHECOSLOVACA', 'pais': 'REP. CHECA' },
        { 'nacionalidad': 'CHILENA', 'pais': 'CHILE' },
        { 'nacionalidad': 'CHINA', 'pais': 'CHINA' },
        { 'nacionalidad': 'CHIPRIOTA', 'pais': 'CHIPRE' },
        { 'nacionalidad': 'COLOMBIANA', 'pais': 'COLOMBIA' },
        { 'nacionalidad': 'COMORENSE', 'pais': 'COMORAS' },
        { 'nacionalidad': 'CONGOLEÑA', 'pais': 'CONGO' },
        { 'nacionalidad': 'COSTARRICENSE', 'pais': 'COSTA RICA' },
        { 'nacionalidad': 'CROATA', 'pais': 'CROACIA' },
        { 'nacionalidad': 'CUBANA', 'pais': 'CUBA' },
        { 'nacionalidad': 'DAHONEYA', 'pais': 'DAHOMEY' },
        { 'nacionalidad': 'DANES', 'pais': 'DINAMARCA' },
        { 'nacionalidad': 'YIBOUTI', 'pais': 'YIBOUTI' },
        { 'nacionalidad': 'DOMINICANA', 'pais': 'REP. DOMINICANA' },
        { 'nacionalidad': 'DOMONIQUESA', 'pais': 'DOMINICA' },
        { 'nacionalidad': 'ECUATORIANA', 'pais': 'ECUADOR' },
        { 'nacionalidad': 'EGIPCIA', 'pais': 'EGIPTO' },
        { 'nacionalidad': 'EMIRATA', 'pais': 'EMIRATOS ARABES UDO.' },
        { 'nacionalidad': 'ERITREA', 'pais': 'ERITREA' },
        { 'nacionalidad': 'ESLOVACA', 'pais': 'ESLOVAQUIA' },
        { 'nacionalidad': 'ESLOVENA', 'pais': 'ESLOVENIA REP.' },
        { 'nacionalidad': 'ESPAÑOLA', 'pais': 'ESPAÑA' },
        { 'nacionalidad': 'ESTONA', 'pais': 'ESTONIA' },
        { 'nacionalidad': 'SUAZI', 'pais': 'SUAZILANDIA' },
        { 'nacionalidad': 'ETIOPE', 'pais': 'ETIOPIA' },
        { 'nacionalidad': 'MACEDONIA', 'pais': 'EX REPÚBLICA YUGOSLAVA DE MACEDONIA' },
        { 'nacionalidad': 'FIJENA', 'pais': 'FIJI' },
        { 'nacionalidad': 'FILIPINA', 'pais': 'FILIPINAS' },
        { 'nacionalidad': 'FINLANDESA', 'pais': 'FINLANDIA' },
        { 'nacionalidad': 'FRANCESA', 'pais': 'FRANCIA' },
        { 'nacionalidad': 'GABIANA', 'pais': 'GAMBIA' },
        { 'nacionalidad': 'GABONA', 'pais': 'GABON' },
        { 'nacionalidad': 'GIORGIANA', 'pais': 'GEORGIA' },
        { 'nacionalidad': 'GHANESA', 'pais': 'GHANA' },
        { 'nacionalidad': 'GRANADEÑA', 'pais': 'GRANADA' },
        { 'nacionalidad': 'GRIEGA', 'pais': 'GRECIA' },
        { 'nacionalidad': 'GUATEMALTECA', 'pais': 'GUATEMALA' },
        { 'nacionalidad': 'GUINESA ECUATORIANA', 'pais': 'GUINEA ECUATORIAL' },
        { 'nacionalidad': 'GUINESA', 'pais': 'GUINEA' },
        { 'nacionalidad': 'BISAUGUINEANO', 'pais': 'GUINEA BISSAU' },
        { 'nacionalidad': 'GUYANESA', 'pais': 'GUYANA' },
        { 'nacionalidad': 'HAITIANA', 'pais': 'HAITI' },
        { 'nacionalidad': 'HONDUREÑA', 'pais': 'HONDURAS' },
        { 'nacionalidad': 'HUNGARA', 'pais': 'HUNGRIA' },
        { 'nacionalidad': 'INDIA', 'pais': 'INDIA' },
        { 'nacionalidad': 'INDONESA', 'pais': 'INDONESIA' },
        { 'nacionalidad': 'BRITANICA', 'pais': 'REINO UNIDO' },
        { 'nacionalidad': 'ESCOSESA', 'pais': 'ESCOCIA – REINO UNIDO' },
        { 'nacionalidad': 'GALÉS', 'pais': 'GALES' },
        { 'nacionalidad': 'INGLESA', 'pais': 'INGLATERRA' },
        { 'nacionalidad': 'NORIRLANDESA', 'pais': 'IRLANDA DEL NORTE' },
        { 'nacionalidad': 'IRAKI', 'pais': 'IRAK' },
        { 'nacionalidad': 'IRANI', 'pais': 'IRAN' },
        { 'nacionalidad': 'IRLANDESA', 'pais': 'IRLANDA' },
        { 'nacionalidad': 'ISLANDESA', 'pais': 'ISLANDIA' },
        { 'nacionalidad': 'MARSHALESA', 'pais': 'ISLAS MARSHALL' },
        { 'nacionalidad': 'SALOMONENSE', 'pais': 'ISLAS SALOMÓN' },
        { 'nacionalidad': 'ISRAELI', 'pais': 'ISRAEL' },
        { 'nacionalidad': 'ITALIANA', 'pais': 'ITALIA' },
        { 'nacionalidad': 'JAMAIQUINA', 'pais': 'JAMAICA' },
        { 'nacionalidad': 'JAPONESA', 'pais': 'JAPON' },
        { 'nacionalidad': 'JORDANA', 'pais': 'JORDANIA' },
        { 'nacionalidad': 'KAZAJA', 'pais': 'KAZAJISTÁN REP.' },
        { 'nacionalidad': 'KATENSA', 'pais': 'KATAR' },
        { 'nacionalidad': 'KENIANA', 'pais': 'KENIA' },
        { 'nacionalidad': 'KIRGUISO', 'pais': 'KIRGUISTÁN' },
        { 'nacionalidad': 'KIRIBATIANA', 'pais': 'KIRIBATI' },
        { 'nacionalidad': 'KUWAITI', 'pais': 'KWAIT' },
        { 'nacionalidad': 'LAOSIANA', 'pais': 'LAO REP.DEM.' },
        { 'nacionalidad': 'LEONESA', 'pais': 'SIERRA LEONA' },
        { 'nacionalidad': 'LESOTHENSA', 'pais': 'LESOTHO' },
        { 'nacionalidad': 'LETONESA', 'pais': 'LETONIA' },
        { 'nacionalidad': 'LIBANESA', 'pais': 'LIBANO' },
        { 'nacionalidad': 'LIBERIANA', 'pais': 'LIBERIA' },
        { 'nacionalidad': 'LIBEÑA', 'pais': 'LIBIA' },
        { 'nacionalidad': 'LIECHTENSTEIN', 'pais': 'LIECHTENSTEIN' },
        { 'nacionalidad': 'LITUANA', 'pais': 'LITUANIA' },
        { 'nacionalidad': 'LUXEMBURGO', 'pais': 'LUXEMBURGO' },
        { 'nacionalidad': 'MADAGASCAR', 'pais': 'MADAGASCAR' },
        { 'nacionalidad': 'MALACA', 'pais': 'FEDE. DE MALASIA' },
        { 'nacionalidad': 'MALAWI', 'pais': 'MALAWI' },
        { 'nacionalidad': 'MALDIVAS', 'pais': 'MALDIVAS' },
        { 'nacionalidad': 'MALI', 'pais': 'MALI' },
        { 'nacionalidad': 'MALTESA', 'pais': 'MALTA' },
        { 'nacionalidad': 'MARFILESA', 'pais': 'COSTA DE MARFIL' },
        { 'nacionalidad': 'MARROQUI', 'pais': 'MARRUECOS' },
        { 'nacionalidad': 'MAURICIANA', 'pais': 'MAURICIO' },
        { 'nacionalidad': 'MAURITANA', 'pais': 'MAURITANIA' },
        { 'nacionalidad': 'MEXICANA', 'pais': 'MÉXICO' },
        { 'nacionalidad': 'MICRONESIA', 'pais': 'MICRONESIA(ESTADOS FEDERADOS DE)' },
        { 'nacionalidad': 'MONEGASCA', 'pais': 'MONACO' },
        { 'nacionalidad': 'MONGOLESA', 'pais': 'MONGOLIA' },
        { 'nacionalidad': 'MONTENEGRINA', 'pais': 'MONTENEGRO' },
        { 'nacionalidad': 'MOZAMBIQUEÑO', 'pais': 'MOZAMBIQUE' },
        { 'nacionalidad': 'NAMIBIA', 'pais': 'NAMIBIA' },
        { 'nacionalidad': 'NAURU', 'pais': 'NAURU' },
        { 'nacionalidad': 'NEOZELANDESA', 'pais': 'NUEVA ZELANDIA' },
        { 'nacionalidad': 'NEPALESA', 'pais': 'NEPAL' },
        { 'nacionalidad': 'NICARAGUENSE', 'pais': 'NICARAGUA' },
        { 'nacionalidad': 'NIGERANA', 'pais': 'NIGER' },
        { 'nacionalidad': 'NIGERIANA', 'pais': 'NIGERIA' },
        { 'nacionalidad': 'NORCOREANA', 'pais': 'COREA DEL NORTE' },
        { 'nacionalidad': 'NORTEAMERICANA', 'pais': 'ESTADOS UNIDOS' },
        { 'nacionalidad': 'NORUEGA', 'pais': 'NORUEGA' },
        { 'nacionalidad': 'OMANA', 'pais': 'OMAN' },
        { 'nacionalidad': 'PAKISTANI', 'pais': 'PAKISTAN' },
        { 'nacionalidad': 'PALAUNANA', 'pais': 'PALAOS' },
        { 'nacionalidad': 'PANAMEÑA', 'pais': 'PANAMA' },
        { 'nacionalidad': 'PAPUANA', 'pais': 'PAPUA NUEVA GUINEA' },
        { 'nacionalidad': 'PARAGUAYA', 'pais': 'PARAGUAY' },
        { 'nacionalidad': 'PERUANA', 'pais': 'PERU' },
        { 'nacionalidad': 'POLACA', 'pais': 'POLONIA' },
        { 'nacionalidad': 'PORTUGUESA', 'pais': 'PORTUGAL' },
        { 'nacionalidad': 'MOLDAVA', 'pais': 'MOLDAVIA REP.' },
        { 'nacionalidad': 'RHODESIANA', 'pais': 'RHODESIA' },
        { 'nacionalidad': 'RUANDA', 'pais': 'RUANDA' },
        { 'nacionalidad': 'RUMANA', 'pais': 'RUMANIA' },
        { 'nacionalidad': 'RUSA', 'pais': 'FEDERACIÓN DE RUSIA' },
        { 'nacionalidad': 'SALVADOREÑA', 'pais': 'EL SALVADOR' },
        { 'nacionalidad': 'SANCRISTOBALEÑA', 'pais': 'SAN CRISTOBAL Y NIEVES' },
        { 'nacionalidad': 'SAMOA OCCIDENTAL', 'pais': 'ESTADO INDEPENDIENTE DE SAMOA' },
        { 'nacionalidad': 'SAN MARINO', 'pais': 'SAN MARINO' },
        { 'nacionalidad': 'SAUDI', 'pais': 'ARABIA SAUDITA' },
        { 'nacionalidad': 'SANVICENTINA', 'pais': 'SAN VICENTE Y LAS GRANADINAS' },
        { 'nacionalidad': 'SANTALUCENSE', 'pais': 'SANTA LUCÍA' },
        { 'nacionalidad': 'SANTOTOMENSE', 'pais': 'SANTO TOMÉ Y PRÍNCIPE' },
        { 'nacionalidad': 'SENEGALESA', 'pais': 'SENEGAL' },
        { 'nacionalidad': 'SINGAPUR', 'pais': 'SINGAPUR' },
        { 'nacionalidad': 'SIRIA', 'pais': 'REPÚBLICA ÁRABE SIRIA' },
        { 'nacionalidad': 'SERVIA', 'pais': 'SERBIA' },
        { 'nacionalidad': 'SEYCHELLENSE', 'pais': 'SEYCHELLES' },
        { 'nacionalidad': 'SIERRALEONESA', 'pais': 'SIERRA LEONA' },
        { 'nacionalidad': 'SOMALIA', 'pais': 'SOMALIA' },
        { 'nacionalidad': 'SRI LANKA', 'pais': 'SRI LANKA (CEYLAN)' },
        { 'nacionalidad': 'SUAZI', 'pais': 'SUAZILANDIA' },
        { 'nacionalidad': 'SUDAFRICANA', 'pais': 'SUDAFRICA' },
        { 'nacionalidad': 'SUDANESA', 'pais': 'SUDAN' },
        { 'nacionalidad': 'SURSUDANÉS', 'pais': 'SUDÁN DEL SUR' },
        { 'nacionalidad': 'SUECA', 'pais': 'SUECIA' },
        { 'nacionalidad': 'SUIZA', 'pais': 'SUIZA' },
        { 'nacionalidad': 'SURCOREANA', 'pais': 'COREA DEL SUR' },
        { 'nacionalidad': 'SURINAMESA', 'pais': 'SURINAME' },
        { 'nacionalidad': 'TAILANDESA', 'pais': 'TAILANDIA' },
        { 'nacionalidad': 'TANZANA', 'pais': 'REPÚBLICA UNIDA DE TANZANÍA' },
        { 'nacionalidad': 'TAYIKA', 'pais': 'TAYIKISTÁN' },
        { 'nacionalidad': 'TIMORENSE', 'pais': 'TIMOR-ORIENTAL' },
        { 'nacionalidad': 'TONGA', 'pais': 'TONGA' },
        { 'nacionalidad': 'TONGO', 'pais': 'TOGO' },
        { 'nacionalidad': 'TRINITENSE', 'pais': 'TRINIDAD Y TOBAGO' },
        { 'nacionalidad': 'TUNECINA', 'pais': 'TUNEZ' },
        { 'nacionalidad': 'TURKMENA', 'pais': 'TURKMENISTÁN' },
        { 'nacionalidad': 'TURCA', 'pais': 'TURQUIA' },
        { 'nacionalidad': 'TUVALUANA', 'pais': 'TUVALU' },
        { 'nacionalidad': 'UCRANIANA', 'pais': 'UCRANIA' },
        { 'nacionalidad': 'UGANDESA', 'pais': 'UGANDA' },
        { 'nacionalidad': 'URUGUAYA', 'pais': 'URUGUAY' },
        { 'nacionalidad': 'VATICANO', 'pais': 'VATICANO' },
        { 'nacionalidad': 'UZBEKA', 'pais': 'UZBEKISTÁN' },
        { 'nacionalidad': 'VANUATUENSE', 'pais': 'VANUATU' },
        { 'nacionalidad': 'VENEZOLANA', 'pais': 'VENEZUELA' },
        { 'nacionalidad': 'VIETNAMITA', 'pais': 'VIETNAM' },
        { 'nacionalidad': 'YEMENITA', 'pais': 'YEMEN REP.' },
        { 'nacionalidad': 'YUGOSLAVA', 'pais': 'YUGOSLAVIA REP.FED.' },
        { 'nacionalidad': 'ZAMBIANA', 'pais': 'ZAMBIA REP.' },
        { 'nacionalidad': 'ZIMBABUENZE', 'pais': 'ZIMBABUE' },
        { 'nacionalidad': 'NEERLANDESA', 'pais': 'PAÍSES BAJOS'
        }
      ];
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/mixins/paises.js